import {CardBody, Col, Modal, Row} from "react-bootstrap";
import React, {useContext, useEffect, useState} from "react";
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";
import {redeemGiftCard} from "../common/api/PortalCustomerApi";
import {AppContext} from "../../lib/AppContext";

export default function CustomerRedeemGiftCard({giftCard, show, handleClose, handleSave}) {
  const [context, setContext] = useContext(AppContext);
  const [giftCardCode, setGiftCardCode] = useState(null);

  const [formActing, setFormActing] = useState(false);
  const [formError, setFormError] = useState(false);

  const handleSubmit = (e) => {
    setFormActing(true);
    setFormError(null);
    let req = {
      giftCardCode: giftCardCode
    }
    redeemGiftCard(req).then((resp) => {
      setFormActing(false);
      if (resp.error) {
        setFormError(resp.message);
        return;
      }

      let _context = {...context};
      _context.toast = {
        message: 'Gift Card Redeemed!',
      }
      setContext({..._context});
      handleSave();
    })
  }

  return (
    <Modal onHide={handleClose} size={'lg'} fullscreen={true} dialogClassName={'psb-page-overlay'}
           show={show}>
      <form id="waiverForm" onSubmit={(e) => {
        e.preventDefault();
        handleSubmit(e);
      }}>
        <Modal.Header closeButton>
          <Modal.Title>Redeem Gift Card</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <CardBody>
            <Row>
              <Col xs={2} sm={4}>
                &nbsp;
              </Col>
              <Col xs={8} sm={4}>
                <h5>Enter Redemption Code</h5>
                <div id={'redeem-gift-card'}>
                  <MDInput
                    onChange={(e) => {
                      setGiftCardCode(e.target.value)
                    }}
                    variant="outlined" type="text" required
                    name="giftCardCode"
                    autoComplete="off"
                    className="form-control"
                    id="giftCardCode"
                    placeholder="Card Code"/>
                </div>
                {formError && <p className={'mt-4'}><b>Notice: </b>{formError}</p>}
              </Col>
            </Row>
          </CardBody>
          <hr/>

        </Modal.Body>

        <Modal.Footer>

          <MDButton type="submit" color="info" disabled={formActing}>
            {formActing ? 'Redeeming...' : 'Redeem'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}